/** `GET payments/overdue/` — status OVERDUE, or OPEN/PARTIAL past due date. */
import { getOverduePayments } from '../../api/endpoints/payments';
import { PaymentFeedPage } from './PaymentFeedPage';

export function OverduePaymentsPage(): React.JSX.Element {
  return (
    <PaymentFeedPage
      title="Overdue payments"
      queryKey="payments-overdue"
      queryFn={getOverduePayments}
      emptyMessage="No overdue payments."
    />
  );
}

export default OverduePaymentsPage;
